import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { ReadOnlyType, UomSetProps } from 'app/area/codetable/item/types';
import { createUomSetFieldId, getUomSetValidation } from 'app/area/codetable/item/codetable-item-helpers';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const SubstanceSetUomType = (props: UomSetProps) => {

  const { substanceUomSetValue: { uomType, uomSet: { value: currentUomSetValue = undefined } = {} },
    breadcrumbs, codeItem: { substanceUomSet } = {}, updateByKey, resetValidation, codetableOptions, loadCodetableOptions,
    translation, validation, readOnlyConfig } = props;

  const fieldId = createUomSetFieldId(ScreenPicker.uomSetValueType, currentUomSetValue);
  const codetableId = codetableOptionsIds[ScreenPicker.uomSetValueType];

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(fieldId);
    currentUomSetValue && substanceUomSet && updateByKey(ScreenPicker.substanceUomSet,
      substanceUomSet.map(item => item.uomSet.value === currentUomSetValue
        ? {
          ...item,
          [ScreenPicker.uomSetValueType]: value,
          [ScreenPicker.uomSetValue]: undefined
        }
        : item));
  };
  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, {
      ...loadOptionsParams, displayNotSelected: false
    });
  };

  const codeOptions = codetableOptions?.[fieldId]?.codes ?? [] as CodeComplexValue<number>[];
  const uomSetValidation = getUomSetValidation({
    uomSet: currentUomSetValue,
    uomTypeName: ScreenPicker.uomSetValueType,
    uomTypeValue: uomType?.value,
    validation: validation[ScreenPicker.substanceUomSet]
  });
  const defaultValidation = !!validation && !!validation[fieldId] ? validation[fieldId] : undefined;
  const uomValidation = { ...uomSetValidation, ...defaultValidation };

  const finalValidation = { ...uomValidation, ...getDisabledValidation(uomType?.disabled, translation.selected_value_disabled) };
  const readOnly = (readOnlyConfig && readOnlyConfig[ReadOnlyType.all]);

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  return <CodeSinglePicker
    id={fieldId}
    label={translation.default_uom_type}
    valueItem={uomType}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={!!codetableOptions && codetableOptions[fieldId] && codetableOptions[fieldId].fetching}

    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={finalValidation}
  />;
};
